"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const models_1 = require("@osmosys/models");
exports.osmosysAppDefault = {
    adminRole: false,
    adminRoles: false,
    appHasLoaded: false,
    appSettings: undefined,
    breadcrumb: undefined,
    currentUser: undefined,
    currentWorkspace: undefined,
    currentWorkspaceMembership: undefined,
    featureFlags: new models_1.FeatureFlags(),
    isLoggedIn: false,
    loadApp: null,
    mode: 'anonymous',
};
exports.OsmosysAppContext = react_1.default.createContext(exports.osmosysAppDefault);
//# sourceMappingURL=OsmosysAppContext.js.map